import { Injectable } from '@angular/core';
import { BaseService } from '../../../core/service/base-service';
import { QuotationModel } from '../model/quotation-model';
import { HttpClient } from '@angular/common/http';
import { AuthUtilsService } from '../../../core/util/auth-utils.service';
import { Observable } from 'rxjs';
import { FunnelModal } from '../../funnel/modal/funnel-modal';
import { ResponseData } from '../../../core/modal/base-save-update-response';
import { environment } from '../../../../environments/environment';
import { QuotationMailModel } from '../model/quotation-mail-model';
import { PaginationData } from '../../../core/modal/pagination-data';
import { OrderingData } from '../../../core/modal/ordering-data';
import { SalesOrderModal } from '../../sales-order/modal/sales-order-modal';
import { saveAs } from 'file-saver';
import { QuotationPrintModel } from 'src/app/shared/shared-crm/quotation-print/quotation-print.component';
import { PartyDetailModal } from '../../party/modal/party-detail-modal';
import { ProductModal } from '../../product/modal/product-modal';
import { SearchData } from '../../../core/modal/search-data';
@Injectable({
  providedIn: 'root',
})
export class QuotationService extends BaseService<QuotationModel> {
  pagination: { pageIndex: number; perPage: number };
  serverFilterObj: SearchData[] = [];
  constructor(http: HttpClient, authService: AuthUtilsService) {
    super(http, authService);
  }

  getModuleName(): string {
    return 'crm/quotation';
  }

  validate(): boolean {
    return false;
  }

  getAll(): Observable<ResponseData<QuotationModel>> {
    return this.http.get<ResponseData<QuotationModel>>(
      environment.SERVER_URL + 'crm/quotation/getQuotationByLoggedInUser'
    );
  }

  getAllByPagination(param): Observable<ResponseData<QuotationModel>> {
    return this.http.post<ResponseData<QuotationModel>>(
      environment.SERVER_URL + this.getModuleName() + '/getQuotationByLoggedInUser',
      param
    );
    // }
  }

  public sendMail(mailDto: QuotationMailModel) {
    var mediaType = 'application/pdf';
    let url = environment.SERVER_URL + 'crm/quotation/sendMail';
    return this.http.post(url, mailDto, { responseType: 'blob' }).subscribe((response) => {
      var blob = new Blob([response], { type: mediaType });
    });
  }

  public sendMailOnSave(mailDto: any) {
    var mediaType = 'application/pdf';
    let url = environment.SERVER_URL + 'crm/quotation/sendQuotationToMail';
    return this.http.post(url, mailDto, { responseType: 'blob' }).subscribe((response) => {
      var blob = new Blob([response], { type: mediaType });
    });
  }

  public generateSalesOrder(data: SalesOrderModal): Observable<ResponseData<SalesOrderModal>> {
    return this.http.post<ResponseData<SalesOrderModal>>(environment.SERVER_URL + 'chemical/salesOrder/save/v2', data);
  }

  public updateQuotation(event: QuotationModel): Observable<ResponseData<QuotationModel>> {
    return this.http.post<ResponseData<QuotationModel>>(environment.SERVER_URL + 'crm/quotation/update/v2', event);
  }

  public getQNNo(): Observable<ResponseData<any>> {
    return this.http.get<ResponseData<any>>(environment.SERVER_URL + 'crm/quotation/getQNUniqueID');
  }

  public getByModuleNameAndEntityId(id): any {
    return this.http.get(environment.SERVER_URL + 'chemical/printParameter/getByModuleNameAndEntityId/Quotation/' + id);
  }

  getQuotationPrint(reqDto: QuotationPrintModel) {
    var fileName = 'Quotation';
    if (reqDto && reqDto.quotationNo) {
      fileName = reqDto.quotationNo + '_' + reqDto.quotation.customer.companyName.replace(/\s+/g, '');
    }
    var mediaType = 'application/pdf';
    let url = environment.SERVER_URL + 'crm/quotation/pdf';
    this.http.post(url, reqDto, { responseType: 'blob' }).subscribe((response) => {
      var blob = new Blob([response], { type: mediaType });
      saveAs(blob, fileName + '.pdf');
    });
  }

  getQuotationPrintPdf() {
    var fileName = 'Quotation PDF';
    var mediaType = 'application/pdf';
    let url = environment.SERVER_URL + this.getModuleName() + '/export/pdf';
    this.http.get(url, { responseType: 'blob' }).subscribe((response) => {
      var blob = new Blob([response], { type: mediaType });
      saveAs(blob, fileName + '.pdf');
    });
  }

  getQuotationPrintExcel() {
    var fileName = 'Quotation EXCEL';
    var mediaType = 'application/excel';
    let url = environment.SERVER_URL + this.getModuleName() + '/export/excel';
    this.http.get(url, { responseType: 'blob' }).subscribe((response) => {
      var blob = new Blob([response], { type: mediaType });
      saveAs(blob, fileName + '.xls');
    });
  }

  customSearchFn(term: string, item: PartyDetailModal) {
    term = term.toLowerCase();
    let codeFirstName: string = item.firstName ? item.firstName : '';
    let codeLastName: string = item.lastName ? item.lastName : '';
    return (
      item.firstName.toLowerCase().indexOf(term) > -1 ||
      codeFirstName.toLowerCase().match(term) ||
      item.lastName.toLowerCase().indexOf(term) > -1 ||
      codeLastName.toLowerCase().match(term)
    );
  }

  customSearchFnForItem(term: string, item: ProductModal) {
    let replacedKey = term.replace(/[,\.-\s]/g, '');
    let newRegEx = new RegExp(replacedKey, 'gi');
    let purgedName = item.name.replace(/[,\.-\s]/g, '');
    if (newRegEx.test(purgedName)) {
      return true;
    }
    return false;
  }

  getServerFilterObj() {
    return this.serverFilterObj;
  }

  setServerFilterObj(filters: SearchData[]) {
    let filterObj = JSON.parse(JSON.stringify(filters));

    if (filterObj && filterObj.length > 0) {
      if (this.serverFilterObj && this.serverFilterObj.length > 0)
        filterObj.map((fObj) => {
          let objIndex = this.serverFilterObj.findIndex(function (obj) {
            return obj.filterColumn == fObj.filterColumn;
          });
          if (objIndex != -1) {
            this.serverFilterObj[objIndex] = fObj;
          } else {
            this.serverFilterObj.push(fObj);
          }
        });
      else {
        this.serverFilterObj = filterObj;
      }
    } else {
      if (this.serverFilterObj && this.serverFilterObj.length > 0) {
        let serverFilterObj = JSON.parse(JSON.stringify(this.serverFilterObj));
        serverFilterObj = this.serverFilterObj.filter((fObj) => {
          return fObj.filterColumn == 'any';
        });
        this.serverFilterObj = serverFilterObj;
      }
    }
    return this.serverFilterObj;
  }
}
